var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form"},[_c('app-loading',{attrs:{"loading":_vm.loading}},[_c('app-exercises',{attrs:{"parent":"grammar_step","grammar_step":_vm.grammar_step}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }